import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ChannelResult} from '@app/search/store/rh-search';

@Component({
  selector: 'rh-channel-list-item',
  templateUrl: './channel-list-item.component.html',
  styleUrls: ['./channel-list-item.component.scss']
})
export class ChannelListItemComponent {
  public isInSubscriptions: boolean = false;
  @Input() result!: ChannelResult;
  @Input() blocked!: boolean;
  @Output() toggleSubscription: EventEmitter<{ id: string, status: boolean }> = new EventEmitter();
  @Output() openChannel: EventEmitter<{ id: string }> = new EventEmitter();

  constructor() {
  }

  open(ev: Event): void {
    this.openChannel.emit({id: this.result.id});
    ev.stopPropagation();
  }


  toggleSubscriptionClick(): void {
    this.result.hasSubscribed = !this.result.hasSubscribed;
    this.toggleSubscription.emit({id: this.result.id, status: this.result.hasSubscribed});
  }
}
